export default __webpack_public_path__ + "static/media/codewars.47d0ec11.svg";